// eslint-disable-next-line no-restricted-imports
import { Spin as AntSpin } from 'antd';
import { SpinProps } from 'antd/lib/spin';
import { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as SpinnerSVG } from './spinner.svg';

interface LoadingProps extends SpinProps {
  title?: string;
  description?: string;
  css?: boolean;
  light?: boolean;
}

const Spin = styled(AntSpin)`
  &.ant-spin-lg .ant-spin-dot {
    height: var(--layout-04);
    width: var(--layout-04);
  }
`;

const StyledSpinnerSvg = styled(SpinnerSVG)`
  circle {
    stroke: var(--primary-color);
  }
`;

const CSSSpinner = styled.div`
  width: 40px !important;
  height: 40px !important;
  border: 5px solid var(--primary-color);
  border-top-color: transparent !important;
  border-radius: 50%;
  animation: loading 1s linear infinite;

  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LightSpinner = styled(CSSSpinner)`
  border: 5px solid var(--white-80);
`;

export const Loading: FC<React.PropsWithChildren<LoadingProps>> = ({
  children,
  description,
  title,
  css,
  light,
  ...rest
}) => (
  <Spin
    {...rest}
    tip={description}
    indicator={
      css ? light ? <LightSpinner /> : <CSSSpinner /> : <StyledSpinnerSvg />
    }
  >
    {children}
  </Spin>
);

/* NOTE:: This is dummy(stop gap) implementation until we have proper loading page UI */
export const PageLoading = styled(Loading).attrs({ size: 'large' })`
  position: fixed;
  top: calc(50% - 48px);
  left: 50%;
`;
